import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ENTITY_TYPES, OrderService } from 'src/app/order-service.service';
import { Table, Pagination, TableData, TableDataTypes } from 'src/app/shared/types';
import { GuestOrderDetailsService } from './guest-order-details.service';
import { FilterService, DateFilterInput, TextFilterInput,
  SearchableDropDownFilterInput, RangeSliderInput, SingleSearchableDropdown, QuickFilters} from 'src/app/filter.service';
import { HelperService } from 'src/app/helper.service';
import { EntityService } from 'src/app/entity.service';
import { DataService } from '../../data.service';
import { FraudService } from '../../fraud-component/fraud-view.service';
import { Router } from '@angular/router';
const currentDate = new Date();
const startDate = new Date();
startDate.setDate(startDate.getDate() - 1);
export const DEFAULT_DATE = {
  FROM_DATE: new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 31)),
  TO_DATE: currentDate
};

function defaultFiters() {
  let startDuration = HelperService.getDateOnlyV1(new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 31)));
  let endDuration = HelperService.getDateOnlyV1(currentDate);
  return {
    startDuration,
    endDuration,
    cities: [],
    services: [],
    status: 'all'
  };
}

@Component({
  selector: 'app-guest-order-details',
  templateUrl: './guest-order-details.component.html'
})
export class GuestOrderDetailsComponent implements OnInit, OnChanges {
  @Input() customerMobile: string;
  @Input() customerId: string;
  @Input() guestDetailsToggleableHeaders: string[];
  @Output() lastOrderDate: EventEmitter<any> = new EventEmitter();
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
  orderTable: Table;
  currentNumber: any;
  fromDate = DEFAULT_DATE.FROM_DATE;
  toDate = DEFAULT_DATE.TO_DATE;
  filtersApplied = defaultFiters();
  cities: any = [];
  sendInfo: any;
  orders: any[];
  fraudOrdersList: any;
  statusList: any = [
    'all',
    'new',
    'customerCancelled',
    'onTheWay',
    'arrived',
    'started',
    'dropped',
    'expired',
    'aborted'
  ];
  filterCount: any;
  constructor(
    public orderService: OrderService,
    public filterService: FilterService,
    public entityService: EntityService,
    private guestOrderDetailsService: GuestOrderDetailsService,
    private dataService: DataService,
    private router: Router,
    private fraudService: FraudService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.customerMobile) {
      this.customerMobile = changes.customerMobile.currentValue;
      if (this.customerMobile) {
        this.defineOrderTable(this.customerMobile, DEFAULT_DATE.FROM_DATE, DEFAULT_DATE.TO_DATE, this.filtersApplied);
      }
    }
  }

  ngOnInit() {
    this.defineOrderTable(this.customerMobile);
    this.entityService.getCities().subscribe(cities => {
      this.cities.push(...cities);
    });
  }

  changeInHeader(header) {
    this.toggleHeaders.emit(header);
  }

  private declareTable(pageNumber = 0) {

    this.dataService.searchUserCount.subscribe(result => {
      if (!this.currentNumber || (this.currentNumber === result)) {
        this.filterService.appliedFilters = this.filtersApplied;
      } else {
        this.filterService.appliedFilters = {};
        this.filtersApplied = defaultFiters();
      }
      this.currentNumber = result;
    });
    this.orderTable = new Table({
      toggleableHeaders: this.guestDetailsToggleableHeaders,
      selectedHeader: 0,
      headers: {
        dateTime: 'Trip Date \n Start Time',
        orderIdCity: 'Order Id \n City',
        pickupDrop: 'Pickup \n Drop',
        captainName: 'Captain Name',
        discountCashback: 'Discount \n Cashback',
        fare: 'Fare',
        tripDate: 'Requested Date \n Time',
        initiatedBy: 'Initiated By',
        status: 'Status',
        paymentStatus: 'Payment Status',
        overlap: 'Overlap',
        ratings: 'Ratings'
      },
      pagination: new Pagination(pageNumber, 10),
      config: {
        refresh: true,
      },
      onRefresh: () => {
        this.orderTable = null;
        this.ngOnInit();
      },
      appliedFilters: this.filtersApplied,
      filterComponents: [
        new QuickFilters({
          key: 'duration',
          default: '',
          title: 'Duration',
        }),
        new SearchableDropDownFilterInput({
          key : 'cities',
          title: 'Cities',
          values: this.cities,
        }),
        new SingleSearchableDropdown({
          key : 'status',
          title: 'Status',
          values: this.statusList,
        }),
      ],
      onFilter: () => {
        const timeSlot = this.filterService.appliedFilters.duration || ['', ''];
        let duration = [];
        if (!Array.isArray(timeSlot)) {
          duration.push(timeSlot['start']);
          duration.push(timeSlot['end']);
        } else {
          duration = timeSlot;
        }
        let startDuration = duration[0];
        let endDuration = duration[1];
        const cities = this.filterService.appliedFilters.cities;
        const status = this.filterService.appliedFilters.status;
        const filtersApplied = {
          duration: {
            start: startDuration,
            end: endDuration,
          },
          startDuration,
          endDuration,
          cities,
          status,
        };
        Object.assign(this.filtersApplied, filtersApplied);

        if ((startDuration && endDuration) || cities) {
          startDuration = HelperService.isValidDate(new Date(startDuration)) ? new Date(startDuration) : undefined;
          endDuration = HelperService.isValidDate(new Date(endDuration)) ? new Date(endDuration) : undefined;
          return this.defineOrderTable(this.customerMobile, startDuration, endDuration, this.filtersApplied);
        }
        return this.defineOrderTable(this.customerMobile, undefined, undefined, this.filtersApplied);
      },
      data: []
    });
  }

  onPaginationChange(event) {
    this.fillDataToTable(undefined, undefined, this.filtersApplied);
  }


  getOrderList(customerMobile: string, fromDate?: Date, toDate?: Date, filters?: any) {
    this.filterCount = 0;
    const filterKeys = Object.keys(this.filtersApplied);
    const ignoreKeys = ['startDuration', 'endDuration'];
    const dateFilter = [];
    if (this.filtersApplied && this.filtersApplied['duration']) {
      if (this.filtersApplied['duration'].start) {
        dateFilter.push(this.filtersApplied['duration'].start);
      }
      if (this.filtersApplied['duration'].end) {
        dateFilter.push(this.filtersApplied['duration'].end);
      }
    }
    if (dateFilter.length > 0) {
      this.filterCount++;
    }
    for (let i = 0; i < filterKeys.length ; i++) {
      if (Array.isArray(this.filtersApplied[filterKeys[i]]) && (this.filtersApplied[filterKeys[i]]).length > 0) {
        this.filterCount++;
      } else {
        if (this.filtersApplied[filterKeys[i]] && ignoreKeys.indexOf(filterKeys[i]) === -1
            && (this.filtersApplied[filterKeys[i]]).length > 0) {
          this.filterCount++;
        }
      }
    }
    return this.orderService.getOrdersForUser(this.customerId, this.orderTable.pagination, fromDate, toDate, ENTITY_TYPES.CUSTOMER, filters);
  }

  fillDataToTable(fromDate?: Date, toDate?: Date, filters?: any) {
    if (this.customerMobile) {
      this.orderTable.dataWillLoad();
      this.getOrderList(this.customerMobile, fromDate, toDate, filters).subscribe(async({orders, count}) => {
        const orderIds = [];
        this.sendInfo = {lastOrderDate: (orders && orders[0] && orders[0].date) ? HelperService.dateString(orders[0].date) : ' - '};
        this.lastOrderDate.emit(this.sendInfo);
        const self = this;
        const adjustmentsHistory = {};
        function createTableData(value, className?, type?, flag = false, hoverData?) {
          return new TableData({
            data: value,
            type: type ? type : TableDataTypes.DATA,
            flag: flag,
            hoverData: hoverData ? hoverData : null,
            className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
            onClick: (data) => {
              const newRelativeUrl = self.router.createUrlTree([`/order/${data._id.data}`]);
              const baseUrl = window.location.href.replace(self.router.url, '');
              window.open(baseUrl + newRelativeUrl, '_blank');
            }
          });
        }

        const orderIdss = orders.map(o => o._id);

        this.fraudOrdersList = await this.fraudService.checkFraudOrders({ orders: orderIdss }).toPromise();

        const tripStartTimeMap = await HelperService.fetchTripStartTimeMap(
          orders,
          'guestTripId',
          (ids, date) => this.guestOrderDetailsService.getTripsBulk(ids, date).toPromise()
        );

        const overlapScoreMap = await HelperService.fetchOverlapScoreMap(
          orders,
          (orderIds) => this.guestOrderDetailsService.getPoolTripsBulk(orderIds).toPromise()
        );

        // Client-side sort by tripDate + startTime (desc) — cross-page order follows server sort.
        const sortedOrders = HelperService.sortByTripDateAndStartTime(orders, tripStartTimeMap, 'guestTripId');

        this.orders = sortedOrders.map((order, i) => {
          const orderId = order._id;
          orderIds.push(orderId);
          const self = this;
          const orderDate = new Date(order.date);
          const flag = this.fraudOrdersList.orders[orderId] ? true : false;

          const { initiatedByDisplay } = HelperService.formatPoolDataDisplay(order.poolData);
          const guestTripId = order.poolData && order.poolData.guestTripId;
          const tripDateRaw = (order.poolData && order.poolData.tripDate) || '';
          const startTime = HelperService.getTripStartTime(tripStartTimeMap, guestTripId, tripDateRaw);
          const { tripDateDisplay, startTimeDisplay } = HelperService.formatTripDateTimeDisplay(tripDateRaw, startTime);
          const dateTimeDisplay = tripDateRaw ? (tripDateDisplay + '\n' + startTimeDisplay) : 'NA';
          const overlapDisplay = order.status === 'dropped'
            ? HelperService.formatOverlapDisplay(overlapScoreMap[String(order._id)])
            : '-';

          return {
            _id: createTableData(orderId),
            dateTime: createTableData(dateTimeDisplay, null, null, flag),
            orderIdCity: new TableData({
              data: order.orderId + '\n' + order.city,
              type: TableDataTypes.DATA,
              className: 'cursor-pointer whiteSpacePre',
              onClick: (data) => {
                const newRelativeUrl = self.router.createUrlTree([`/order/${data._id.data}`]);
                const baseUrl = window.location.href.replace(self.router.url, '');
                window.open(baseUrl + newRelativeUrl, '_blank');
              }
            }),
            pickupDrop: createTableData(order.pickup + '\n' + order.drop),
            discountCashback: createTableData(order.guestDiscount + '\n' + order.cashback, 'preserve-whitespace'),
            captainName: createTableData(order.riderName),
            fare: createTableData(order.earnings),
            tripDate: createTableData(HelperService.dateString(orderDate) + '\n' + order.orderTime),
            initiatedBy: createTableData(initiatedByDisplay),
            ratings: createTableData(order.riderRating),
            status: createTableData(order.status, 'capitalize whiteSpacePre', null, false, order.cancelReason || null),
            paymentStatus: createTableData(order.paymentStatus, 'capitalize whiteSpacePre'),
            overlap: createTableData(overlapDisplay)
          };
        });
        this.orderTable.data = this.orders;
        this.orderTable.filterCount = this.filterCount;
        this.orderTable.pagination.count = count;
      });
      if (!this.sendInfo) {
        this.lastOrderDate.emit('empty');
      }

    }
  }

  isEmpty(value) {
    return (value == null || value.length === 0);
  }

  defineOrderTable(customerMobile: string, fromDate = DEFAULT_DATE.FROM_DATE, toDate = DEFAULT_DATE.TO_DATE,
    filters = this.filtersApplied) {
    this.declareTable();
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.fillDataToTable(fromDate, toDate, filters);
  }
}
